import React, { useState } from 'react';
import { Col, Drawer, Form, Input, message, Row, Select, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import UsersServices from '../../../services/usersServices';
import { useSelector } from 'react-redux';
import { DrawerFormButtons } from '../../../components/common/drawersFormButtons';
import { drawerWidth, formItemLayout, notifyMessages } from '../../../utils/constants';


const UpdateOrderItem = ({ open, onClose, recordData, onOrderItemSave }: { open: boolean, onClose: () => void, recordData: any, onOrderItemSave: (values: any) => void }) => {

    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const { roles } = useSelector((state: any) => state.roles);

    const saveData = async (values: any ) => {
       onOrderItemSave(values);

        // setLoadingButton(true);
        // try {
        //     const respData = await UsersServices.updateUser(values);

        //     if (respData.success) {
        //         message.success(notifyMessages.success);
        //         getUsers();
        //         onClose();
        //     }
        //     else {
        //         message.error(notifyMessages.errorAccured);
        //     }
        // } catch (error) {
        //     message.error(notifyMessages.errorAccured);
        // }
        // finally {
        //     setLoadingButton(false);
        // }
    }

    return (
        <Drawer
            title="Edit row"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"updateRow"} />
            }
        >
            <Form
                id="updateRow"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>

                    <Form.Item name="id" initialValue={recordData.id} hidden={true}></Form.Item>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label="Number"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.name}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                        <Form.Item
                            label="Code"
                            name="surname"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                            initialValue={recordData.surname}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                  
                </Row>
            </Form>
        </Drawer>
    );
}
export default UpdateOrderItem;